export const resolveVuetifyTheme = (): 'light' => {
  return 'light'
}
